<template>
	<div class="invite-code-signup">
		<h1 v-t="'groupinvites_join_title'" />
		<CodeForm v-model="code" large @keyup.enter="submit" />
		<Button
			pronto
			large
			block
			:disabled="!code"
			:to="{ name: 'invite', params: { code } }"
		>
			{{ $t('common_button_next') }}
		</Button>
	</div>
</template>

<script>
import { Button } from '@/components/common'
import CodeForm from './CodeForm'

export default {
	name: 'InviteCode',
	components: { CodeForm, Button },
	data() {
		return { code: null }
	},

	methods: {
		submit() {
			if (!this.code) return
			const code = this.code
			this.$router.push({ name: 'invite', params: { code } })
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.invite-code-signup {
	> h1 {
		@include fontFamily(500);
		font-size: 28px;
		color: var(--neutral-800);
		text-align: center;
		margin: 14px 0 40px 0;
	}
	.pronto-btn {
		margin-top: 80px;
	}
}
</style>
